import React from 'react'

/* Style */
import './PublicPhotos.css'

/**
 * Modules
 */
import { Button, Spin, Modal } from 'antd'

const PublicPhotosView = (props) => {
    /* Render all photos */
    let arrayOfPhotos = props.arrayOfPhotos.map((photo, index) => {
        return (
            <div
                className='publicChampsCard'
                key={photo.title}
            >
                <div className='publicChampsCardImg' style={{ backgroundImage: `url(${photo.img})` }} onClick={() => props.openPhotoDialog(index)} />
                <div className='publicChampsCardTitle'>{photo.title}</div>
                {props.userIsLogged ?
                    <Button
                        type='danger'
                        className='PublicPhotosDeleteButton'
                        onClick={() => props.removePhoto(photo.__key)}
                    >Excluir foto</Button> : null
                }
            </div>
        )
    })

    return (
        <div className='publicChampsCentralDiv'>
            <a id="photos"><div style={{ height: '80px' }} /></a>

            <div className='publicHomeAdSense'></div>

            {props.loading ?
                <Spin style={{ width: '100%', marginTop: '50px' }} /> :
                <div className='publicChampsBody'>
                    <h4>Fotos</h4>
                    {arrayOfPhotos}
                </div>
            }

            <div style={{ clear: 'both' }}></div>

            <input id='selectPhoto' type='file' style={{ display: "none" }} onChange={(input) => props.getPhoto(input)} />
            {props.userIsLogged ?
                <div className='PublicPhotosAddButtonContent'>
                    <Button
                        onClick={() => props.choosePhoto()}
                        style={{ width: '300px' }}
                    >
                        Adicionar foto
                    </Button>
                </div> :
                null
            }

            <Modal
                visible={props.photoDialog}
                title={props.choosedPhoto.title}
                onCancel={props.closePhotoDialog}
                width={800}
                footer={[
                    <Button key='close' onClick={() => props.closePhotoDialog()}>Fechar</Button>
                ]}
            >
                <div style={{ width: '100%', height: '400px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${props.choosedPhoto.img})` }}></div>
            </Modal>
        </div>
    )
}

export default PublicPhotosView